"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconInputGroupAddon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _InputGroupAddon = require("./InputGroupAddon");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var IconInputGroupAddon = (0, _styledComponents.default)(function (_ref) {
  var addonType = _ref.addonType,
    onClick = _ref.onClick,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_InputGroupAddon.InputGroupAddon, {
    addonType: addonType,
    onClick: onClick,
    children: children,
    className: className
  });
}).attrs(function (_ref2) {
  var onClick = _ref2.onClick,
    _ref2$clickable = _ref2.clickable,
    clickable = _ref2$clickable === void 0 ? null : _ref2$clickable;
  return {
    clickable: !!(clickable !== null && clickable !== void 0 ? clickable : onClick)
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  user-select: none;\n  cursor: ", ";\n  path {\n    fill: ", ";\n  }\n  &:hover {\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_ref3) {
  var clickable = _ref3.clickable,
    disabled = _ref3.disabled;
  return clickable && !disabled ? 'pointer' : 'default';
}, function (_ref4) {
  var disabled = _ref4.disabled,
    theme = _ref4.theme;
  return disabled ? theme.colors.secondaryShade2 : theme.colors.tertiaryShade;
}, function (_ref5) {
  var clickable = _ref5.clickable,
    disabled = _ref5.disabled,
    theme = _ref5.theme;
  return (clickable !== null && clickable !== void 0 ? clickable : disabled) ? theme.colors.secondaryShade2 : theme.colors.tertiaryShade;
});
exports.IconInputGroupAddon = IconInputGroupAddon;